import { render, staticRenderFns } from "./tixian02.vue?vue&type=template&id=6108d4fd&scoped=true"
import script from "./tixian02.vue?vue&type=script&lang=js"
export * from "./tixian02.vue?vue&type=script&lang=js"
import style0 from "./tixian02.vue?vue&type=style&index=0&id=6108d4fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6108d4fd",
  null
  
)

export default component.exports